import ajax from "@/lib/ajax";

// 查询宣教计划
export async function GetEducationPlanList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducationPlanIndex/QueryEducationPlanList`, payload);
    return res.data.result;
}

/**
 * 停用宣教计划
 * @param payload
 */
export async function StopEducationPlan(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducationPlanIndex/EducationPlanStop`, payload);
    return res.data.result;
}

/**
 * 启用宣教计划
 * @param payload
 */
export async function StartEducationPlan(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducationPlanIndex/EducationPlanStart`, payload);
    return res.data.result;
}

/**
 * 读宣教步骤
 * @param payload 
 */
export async function getPlanStepList(payload: any) {
    let res = await ajax.post('/api/services/app/PDEducationPlanIndex/queryPlanStepList', payload)
    return res.data.result
}

/**
 * 读宣教步骤材料
 * @param payload 
 */
export async function getPlanStepDetailList(payload: any) {
    let res = await ajax.post('/api/services/app/PDEducationPlanIndex/queryPlanStepDetailList', payload)
    return res.data.result
}

/**
 * 删除宣教步骤
 * @param id 
 */
export async function DeletePlanStep(id: number) {
    let res = await ajax.delete(`/api/services/app/PDEducationPlanIndex/DeletePlanStep?id=` + id);
    return res.data.result;
}
/**
 * 删除宣教步骤材料
 * @param id 
 */
export async function DeletePlanStepDetail(id: number) {
    let res = await ajax.delete(`/api/services/app/PDEducationPlanIndex/DeletePlanStepDetail?id=` + id);
    return res.data.result;
}

/**
 * 新增宣教计划
 * @param payload 
 */
export async function InsertEducationPlan(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducationPlanIndex/InsertEducationPlan`, payload);
    return res.data.result;
}

/**
 * 修改宣教计划
 * @param payload
 */
export async function UpdateEducationPlan(payload: any) {
    let res = await ajax.put(`/api/services/app/PDEducationPlanIndex/UpdateEducationPlan`, payload);
    return res.data.result;
}   


/**
 * 新增宣教计划步骤
 * @param payload 
 */
export async function InsertEducationPlanStep(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducationPlanIndex/InsertEducationPlanStep`, payload);
    return res.data.result;
}

/**
 * 修改宣教计划步骤
 * @param payload
 */
export async function UpdateEducationPlanStep(payload: any) {
    let res = await ajax.put(`/api/services/app/PDEducationPlanIndex/UpdateEducationPlanStep`, payload);
    return res.data.result;
}   

/**
 * 新增宣教计划步骤材料
 * @param payload
 */
export async function SaveEducationPlanStepDetail(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducationPlanIndex/InsertEducationPlanStepDetail`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdEducationPlan/pdEducationPlan/index.ts